import { render, staticRenderFns } from "./SingleTypeHorizontalMultiColumnChart.vue?vue&type=template&id=12809c7b&"
import script from "./SingleTypeHorizontalMultiColumnChart.vue?vue&type=script&lang=js&"
export * from "./SingleTypeHorizontalMultiColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports